import { render } from "./ApplePayIcon.vue?vue&type=template&id=7363a4ff"
import script from "./ApplePayIcon.vue?vue&type=script&lang=js"
export * from "./ApplePayIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__